import { useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Divider,
  CircularProgress,
} from "@mui/material";
import { CustomButton } from "../ReusableComponents/CustomButton";
import { client } from "../../lib/Client";
import theme from "../../theme";
import {
  SPACING,
  BUTTON_FEATURES,
  LOGO_FEATURES,
  ICON_FEATURES,
  COMPONENT_FEATURES,
  COMPONENT_SPACING,
} from "../../utils/constants/designConstants";

export const UserLogin = () => {
  const [isLoading, setIsLoading] = useState(false);

  const initiateMSLogin = async () => {
    try {
      setIsLoading(true);
      const response = await client.get("auth/azure/authorize");
      window.location.href = response.data.authorization_url;
    } catch (error) {
      console.error("Error initiating Microsoft login:", error);
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "80vh" }}
    >
      <Paper
        elevation={3}
        sx={{
          p: COMPONENT_SPACING.PAPER_PADDING,
          width: COMPONENT_SPACING.PAPER_WIDTH,
          textAlign: "center",
          borderRadius: COMPONENT_FEATURES.PAPER_BORDER_RADIUS,
          minHeight: COMPONENT_SPACING.PAPER_MIN_WIDTH,
          backgroundImage: `url(/assets/loginForm.jpg)`,
          backgroundSize: "cover",
          backgroundPosition: "center top",
        }}
      >
        {/* Logo */}
        <Box
          component="img"
          src="/assets/blackAnvilLogo.png"
          alt="Black anvil logo with text"
          sx={{
            width: LOGO_FEATURES.LOGO_WIDTH,
            height: LOGO_FEATURES.LOGO_HEIGHT,
            mb: LOGO_FEATURES.LOGO_SPACING,
          }}
        />

        {/* Divider */}
        <Divider
          sx={{
            mb: SPACING.DIVIDER_SPACING,
            borderColor: "secondary.lightBlack",
          }}
        />

        {/* Welcome Message */}
        <Box sx={{ mb: BUTTON_FEATURES.BUTTON_SPACING }}>
          <Typography variant="subtitle2" component="h1">
            Welcome Back
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 600, color: "text.secondary" }}>
            Please log in to your account
          </Typography>
        </Box>

        {/* Login Button */}
        <CustomButton
          text={"Log in with Microsoft"}
          disabled={isLoading}
          onClick={() => {
            initiateMSLogin();
          }}
          fullWidth
          backgroundColor="primary.black"
          color="primary.white"
          startIcon={
            isLoading ? (
              <CircularProgress
                size={ICON_FEATURES.ICON_SIZE}
                sx={{ color: "primary.white" }}
              />
            ) : (
              <img
                src="/assets/microsoft.png"
                alt="Microsoft Logo"
                style={{
                  width: ICON_FEATURES.ICON_SIZE,
                  height: ICON_FEATURES.ICON_SIZE,
                }}
              />
            )
          }
          sx={{
            fontSize: "12px",
            borderRadius: theme.borderRadius.small,
          }}
        />
      </Paper>
    </Box>
  );
};
